import React from 'react'
import styled from 'styled-components'

const IconButton = ({ icon, svgColor, ref, ...props }) => {
    return (
        <ButtonContainer {...props} ref={ref} >
            {icon}
        </ButtonContainer>
    )
}

export default IconButton

const ButtonContainer = styled.button`
display:flex;
align-items:center;
justify-content:center;
color:${({ theme }) => theme.primaryButton.color};
background:none;
border:none;
cursor:pointer;
position:relative;

`